export const tabs = {
  SELL: 'SELL',
  BUY: 'BUY',
  OPERATIONS: 'OPERATIONS',
  CONFIG: 'CONFIG',
};
